"use client"

import { useEffect, useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { getPendingTransactionsByUserId, updateStatusTransaction } from "@/app/adapters/api"
import { useDispatch, useSelector } from "react-redux"
import { selectLanguage, selectUser } from "@/app/redux/store"
import { formatShortDate } from "@/app/utils/formatDates"
import { formatCurrency } from "@/app/utils/formatNumbers"
import Link from "next/link"
import { useRouter } from "next/navigation"

export default function PendingInvestments() {

  const lang = useSelector(selectLanguage)
  const user = useSelector(selectUser)
  const router = useRouter()

  const [open, setOpen] = useState(false)
  const [transactions, setTransactions] = useState<any>([])

	useEffect(() => {
		getPendingTransactionsByUserId(user.id)
			.then((response: any) => {
        if (response.data.transactions.length > 0) {
          setTransactions(response.data.transactions)
          setOpen(true)
          console.log("transactions recieved")
        }
			})
      .finally(() => {
      })
	}, [])

  const handleNavToInvestments = (transaction: any) => { 
    router.push(`/investment/step${transaction.step + 1}/?id=${transaction.id}`)
    setOpen(false)
  }

  const handleDeleteTransaction = (id: number) => {
    updateStatusTransaction(id, {status: 'cancelled'})
      .then((response: any) => {
        window.location.reload();
      })
      .finally(() => {
      });
  }

  return (
    <Dialog open={open}>
      <DialogContent className="w-full">
        <DialogHeader>
          <DialogTitle><p className="text-primary">{lang === 'en' ? 'Pending investments' : 'Inversiones pendientes'}</p></DialogTitle>
        </DialogHeader>
        <div>
          <table>
            {transactions.map((transaction: any) => {
              return (
                <tr key={transaction.id}>
                  <td className="p-2 w-1/6">
                    {formatShortDate(transaction.date, lang)}
                  </td>
                  <td className="p-2 w-3/6 text-primary font-semibold">
                    {transaction.projectName}
                  </td>
                  <td className="p-2 w-1/6 text-right">
                    {
                      transaction.amount > 0 ?
                      formatCurrency(transaction.amount, lang)
                      :
                      <>{lang === 'en' ? 'Pending' : 'Pendiente'}</>
                    }
                  </td>
                  <td className="p-2 w-1/6 text-center">
                    {
                      transaction.status === 'accepted'
                      ?
                        <Button onClick={() => handleNavToInvestments(transaction)} 
                                variant={'successRounded'}>
                                  {lang === 'en' ? 'Pay it' : 'Abonar'}
                        </Button>
                      :
                      <>
                        {
                          transaction.step > 2 ?
                          <Button onClick={() => handleNavToInvestments(transaction)} 
                                  variant={'successRounded'}>
                                    {lang === 'en' ? 'Complete' : 'Completar'}
                          </Button>
                          :
                          <Button onClick={() => handleNavToInvestments(transaction)} 
                                  variant={'successRounded'}>
                                    {lang === 'en' ? 'Resume' : 'Continuar'}
                          </Button>
                        }
                      </>
                    }
                  </td>
                  <td className="p-2 w-1/6 text-center">
                      <Button 
                        onClick={() => handleDeleteTransaction(transaction.id)}
                        variant={'dangerRounded'}>
                        {lang === 'en' ? 'Delete' : 'Borrar'}
                      </Button>
                  </td>
                </tr>
              )
            })}
          </table>
        </div>
        <DialogFooter className="sm:justify-end">
          <DialogClose asChild>
            <Button type="button" variant="secondary" onClick={() => setOpen(false)}>
              Cerrar
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
